import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  SeleccionarIdioma,
  // SeleccionarLocalidad,
  CrearCuenta,
  ActivarCuenta,
  Ingresar,
  OlvidoSuClave,
  IngresarCodigoRecuperacionClave,
  CambiarClave,
  ReenviarCodigoActivacion,
  CerrarSesion,
  // Splash,
  Error404,
  // RevisarGps,
  PruebaTokenFirebase,
} from "../pages/Public";

export function PublicRouter() {
  return (
    <Routes>
      <Route path="/SeleccionarIdioma/*" element={<SeleccionarIdioma />} />
      {/* <Route
        path="/SeleccionarLocalidad/*"
        element={<SeleccionarLocalidad />}
      /> */}
      <Route path="/CrearCuenta/*" element={<CrearCuenta />} />
      <Route path="/ActivarCuenta/*" element={<ActivarCuenta />} />
      <Route path="/Ingresar/*" element={<Ingresar />} />
      {/* <Route path="/RevisarGps/*" element={<RevisarGps />} /> */}
      <Route path="/OlvidoSuClave/*" element={<OlvidoSuClave />} />
      <Route
        path="/IngresarCodigoRecuperacionClave/*"
        element={<IngresarCodigoRecuperacionClave />}
      />
      <Route path="/CambiarClave/*" element={<CambiarClave />} />
      <Route
        path="/ReenviarCodigoActivacion/*"
        element={<ReenviarCodigoActivacion />}
      />
      <Route path="/CerrarSesion/*" element={<CerrarSesion />} />
      {/* <Route path="/Splash/*" element={<Splash />} /> */}
      <Route path="/PruebaTokenFirebase/*" element={<PruebaTokenFirebase />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}
